// extracted by mini-css-extract-plugin
export default {"iconHeader":"ModalIndicador_iconHeader__J3zhm"};